import React from 'react';
import { Icon } from '@upsales/components';
import SupersearchResultHeader from 'Components/Supersearch/SupersearchResultHeader';

type Action = 'chat' | 'delegate';

type Props = {
	query: string;
	closeSearch: () => void;
	showPrompt?: boolean;
};

const SupersearchAIActions = ({ query, closeSearch, showPrompt = true }: Props) => {
	const t = Tools.$translate;
	const trimmed = query.trim();

	if (!Tools.FeatureHelper.hasSoftDeployAccess('QUICK_SEARCH_AI')) {
		return null;
	}

	if (trimmed.length === 0) {
		return null;
	}

	const handleClick = (action: Action) => {
		console.log('[Supersearch AI]', { action, query: trimmed });
		closeSearch();
	};

	return (
		<div className="supersearch-ai-actions">
			<SupersearchResultHeader title={t('default.upsalesAI')} icon="magic" />
			<div className="supersearch-ai-actions__body">
				{showPrompt && <div className="supersearch-ai-actions__prompt">{trimmed}</div>}
				<div className="supersearch-ai-actions__buttons">
					<button
						type="button"
						className="supersearch-ai-actions__button"
						onClick={() => handleClick('chat')}
						data-test-id="supersearch-ai-chat"
					>
						<Icon name="magic" />
						<span>{t('navbar.quickSearch.ai.chat')}</span>
					</button>
					<button
						type="button"
						className="supersearch-ai-actions__button"
						onClick={() => handleClick('delegate')}
						data-test-id="supersearch-ai-delegate"
					>
						<Icon name="magic" />
						<span>{t('navbar.quickSearch.ai.delegate')}</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default SupersearchAIActions;
